export type LogLevel = 'debug' | 'info' | 'warn' | 'error';

export type LogFormat = 'text' | 'jsonl' | 'json-pretty';

export type LogFormatter = (entry: LogEntry) => string | [string, ...unknown[]];

export interface LogEntry {
  timestamp: string;
  level: LogLevel;
  category: string;
  message: string | unknown;
  data?: unknown[];
}

export interface LoggerOptions {
  minLevel?: LogLevel;
  enabled?: boolean;
  format?: LogFormat | LogFormatter;
}

export const LOG_LEVELS: Record<LogLevel, number> = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3,
};
